import { AlertTitle, Typography } from "@mui/material"
import Collapse from "@mui/material/Collapse"
import React, { useState } from "react"

import { mapAmendFailureText } from "../../../utils/submitApplication/submitApplicationUtils"
import AppAlert from "../../dataDisplay/alerts/appAlert"
import {
    FONT_VARIANT,
    FONT_WEIGHT,
} from "../../installerInterface/installerSingleApplicationStatus"

interface IAmendmentFailedAlertProps {
    lastAmendmentFailed: boolean
    amendmentFailureCategory: string
}

const AmendmentFailedAlert = ({
    lastAmendmentFailed,
    amendmentFailureCategory,
}: IAmendmentFailedAlertProps): React.ReactElement => {
    const [open, setOpen] = useState(true)

    return (
        <Collapse in={lastAmendmentFailed && open}>
            <AppAlert severity="warning" onClose={() => setOpen(false)}>
                <AlertTitle>
                    <Typography variant={FONT_VARIANT} fontWeight={FONT_WEIGHT}>
                        Your recent amendment could not be processed
                    </Typography>
                </AlertTitle>
                You recently tried to amend this application. Unfortunately, we
                were unable to process it because
                {
                    mapAmendFailureText(
                        amendmentFailureCategory,
                        "DNO NOT REQUIRED"
                    ).installerSingleAppAlert
                }
            </AppAlert>
        </Collapse>
    )
}

export default AmendmentFailedAlert
